import { GroupSetupConfig } from "../../types/setupTypes";
import { groupTypeIds, groupTypeRoleIds, typeClassIds } from "../../../../../config/constants";
import { Form } from "../../../../../client/form";
import { client } from "../../../../../client/client";
import { getDisplayNameEng, isEmpty } from "../../../../../utils/helpers";
import { UIException, UIText } from "../../../../../client/lang";
import { Group, ProfilePrimitive } from "../../../../../lib/types/dataTypes";
import { createGroupProfile, createSelfMember, getGroupRoles, setLastSetupGroupId } from "../../../../../lib/group-utilities";
import { stateCtrl } from "../../../../../client/state";

export const lspGroupSetup: GroupSetupConfig = {
  id: 1,
  typeClassId: typeClassIds.lspProfile.v1.id,
  get header() { return `${UIText.lsp} ${UIText.profile}` },
  get subHeader() { return UIText.createLSPProfile },
  metadata: { groupTypeRoleId: groupTypeRoleIds.lsp },
  preSetup: (form: Form) => {
    form.set("firstName", (client.defaultProfile.data || {}).firstName);
    form.set("lastName", (client.defaultProfile.data || {}).lastName);
    form.set("email", (client.defaultProfile.data || {}).email);
    form.set("phone", (client.defaultProfile.data || {}).phone);
  },
  onSubmit: async (form: Form) => {
    const pass = form.validate();
    if (!pass) return;
    if (!form || isEmpty(form.data)) {
      return Promise.reject(new UIException("INVALID_LSP_PROFILE_SUBMISSION"));
    }
    const group: Partial<Group> = {
      owner: client.userId,
      parentId: null,
      groupName: getDisplayNameEng(form.data),
      typeId: groupTypeIds.lsp
    };
    const profile: ProfilePrimitive = {
      type: 3,
      typeClassId: typeClassIds.lspProfile.v1.id,
      typeClassVersion: typeClassIds.lspProfile.v1.version,
      data: form.toJSON()
    };
    return createGroupProfile(group, profile, groupTypeRoleIds.lsp)
    .then(setLastSetupGroupId)
    .then(getGroupRoles)
    .then(createSelfMember)
    .then(client.getAndStoreUserGroupsAndMembers);
  },
  get postSetupUrl() { return `/Group/${stateCtrl.lastSetupGroupId}` }
};